import React from 'react';
import './ConfirmDialog.css';

interface ConfirmDialogProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  message,
  onConfirm,
  onCancel,
}) => (
  <div className="modal-overlay">
    <div className="modal">
      <p>{message}</p>
      <button onClick={onConfirm}>Ja</button>
      <button onClick={onCancel}>Nein</button>
    </div>
  </div>
);

export default ConfirmDialog;
